const getMandatoryEnv = require("../../utils/getMandatoryEnv");

export const { mySrcmConfig } = getMandatoryEnv(["mySrcmConfig"]);

export const l = (p) => p.toLowerCase().trim();
